import { plural } from '@cian/utils';
import { IFactoid } from '../../types/project';
import { IApplicationState } from '../../types/redux';

export const selectFactoids = (state: IApplicationState): IFactoid[] => {
  const { area, floorCount, constructionTime } = state.projectData.project;

  return [
    area && { value: `${area} м²`, title: 'площадь', fullTitle: 'Площадь дома', id: 'area' },
    floorCount && {
      value: floorCount,
      title: plural(floorCount, ['этаж', 'этажа', 'этажей']),
      fullTitle: 'Этажей в доме',
      id: 'floor',
    },
    constructionTime && {
      value: constructionTime,
      title: 'срок строительства',
      fullTitle: 'Срок строительства',
      id: 'construction-time',
    },
  ].filter(Boolean) as IFactoid[];
};
